import { useShallow } from "zustand/react/shallow";

import useAssistantPanelAvailableViews from "../hooks/useAvailableViews";
import useAssistantPanelStore from "../Layout/useStore";
import { ASSISTANT_PANEL_DEFAULT_VIEW } from "../constants";
import { AssistantPanelView } from "../Layout/types";
import AssistantPanelChat from "../Chat";
import AssistantPanelLearn from "../Learn";

const AssistantPanelContent = () => {
  const view = useAssistantPanelStore(useShallow((state) => state.view));
  const availableViews = useAssistantPanelAvailableViews();

  const defaultView = availableViews.includes(AssistantPanelView.CHAT)
    ? ASSISTANT_PANEL_DEFAULT_VIEW
    : availableViews[0];

  const activeView = availableViews.includes(view) ? view : defaultView;

  switch (activeView) {
    case AssistantPanelView.CHAT:
      return <AssistantPanelChat />;
    case AssistantPanelView.LEARN:
      return <AssistantPanelLearn />;
    default:
      return null;
  }
};

export default AssistantPanelContent;
